function requiredString(label) {
  return this.ensure().required(label || 'Required');
}
export default requiredString;
